import { render, staticRenderFns } from "./EmptyForm.vue?vue&type=template&id=1cfc9d6e&"
import script from "./EmptyForm.vue?vue&type=script&lang=js&"
export * from "./EmptyForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports